"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useIsLiveEvent = exports.useAttendeeData = void 0;

var _logger = _interopRequireDefault(require("js-utils/logger"));

var _react = require("react");

var _api = require("../api");

var _orders = require("../lib/orders");

var _dates = require("../lib/dates");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var useAttendeeData = function useAttendeeData(_ref) {
  var hoursAheadPreview = _ref.hoursAheadPreview,
      isAuthenticated = _ref.isAuthenticated;

  var _useState = (0, _react.useState)(null),
      _useState2 = _slicedToArray(_useState, 2),
      userData = _useState2[0],
      setUserData = _useState2[1];

  (0, _react.useEffect)(function () {
    var getUserData = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var isUserAuthenticated, user, userOrders, userOrdersInRange;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                isUserAuthenticated = isAuthenticated;

                if (!(userData === null)) {
                  _context.next = 26;
                  break;
                }

                if (!(typeof isUserAuthenticated !== 'boolean')) {
                  _context.next = 13;
                  break;
                }

                _context.prev = 3;
                _context.next = 6;
                return (0, _api.getUser)();

              case 6:
                user = _context.sent;

                if (user) {
                  isUserAuthenticated = true;
                }

                _context.next = 13;
                break;

              case 10:
                _context.prev = 10;
                _context.t0 = _context["catch"](3);
                //Expected failure here if the user isn't
                //logged in. No need to log issue.
                setUserData(false);

              case 13:
                if (!isUserAuthenticated) {
                  _context.next = 26;
                  break;
                }

                _context.prev = 14;
                _context.next = 17;
                return (0, _api.getUserOrders)();

              case 17:
                userOrders = _context.sent;
                userOrdersInRange = (0, _orders.getOrdersInRange)(userOrders.orders, hoursAheadPreview);
                setUserData({
                  userOrders: userOrdersInRange
                });
                _context.next = 26;
                break;

              case 22:
                _context.prev = 22;
                _context.t1 = _context["catch"](14);

                _logger.default.error('Error getting user orders:', {
                  error: _context.t1.message ? _context.t1.message : _context.t1
                });

                setUserData(false);

              case 26:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[3, 10], [14, 22]]);
      }));

      return function getUserData() {
        return _ref2.apply(this, arguments);
      };
    }();

    getUserData();
  }, [hoursAheadPreview, userData, isAuthenticated]);
  return userData;
};

exports.useAttendeeData = useAttendeeData;

var useIsLiveEvent = function useIsLiveEvent(localizedEventStart) {
  var _useState3 = (0, _react.useState)((0, _dates.checkIfEventLive)(localizedEventStart)),
      _useState4 = _slicedToArray(_useState3, 2),
      isLive = _useState4[0],
      setLive = _useState4[1];

  var intervalId = (0, _react.useRef)(null);

  var clearInterval = function clearInterval() {
    if (intervalId.current) {
      var invtervalId = intervalId.current;
      intervalId.current = null;
      window.clearInterval(invtervalId);
    }
  };

  var intervalCallBack = function intervalCallBack() {
    var isEventLive = (0, _dates.checkIfEventLive)(localizedEventStart);

    if (isEventLive) {
      setLive(true);
      clearInterval();
    }

    return;
  };

  if (!isLive && !!localizedEventStart && !intervalId.current) {
    intervalId.current = window.setInterval(intervalCallBack, 10000);
  }

  (0, _react.useEffect)(function () {
    setLive((0, _dates.checkIfEventLive)(localizedEventStart));
  }, [localizedEventStart]);
  return isLive;
};

exports.useIsLiveEvent = useIsLiveEvent;
//# sourceMappingURL=index.js.map